import { axios } from '@/utils/request'

const api = {
  trainOverview: '/exam/trainOverview',
  trainOverview2: '/exam/model',
  trainOverview3: '/exam/trainInfo',
  trainOverview4: '/exam/interactive'
}

//强制提醒
export function insertRemind (parameter) {
  return axios({
    url: api.trainOverview2 + '/insertRemind',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

//排序
export function updateSort (parameter) {
  return axios({
    url: api.trainOverview3 + '/updateSort',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

// 配件型号
export function selectModel (parameter) {
  return axios({
    url: api.trainOverview + `/selectModel/${parameter}`,
    method: 'get',
    params: parameter
  })
}

// 品牌名称
export function selectBrand (parameter) {
  return axios({
    url: api.trainOverview + `/selectBrand/${parameter}`,
    method: 'get',
    params: parameter
  })
}

// 删除 禁用
export function changeStatus (parameter) {
  return axios({
    url: api.trainOverview + '/changeStatus',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}


// 保存培训型号

export function insert (parameter) {
  return axios({
    url: api.trainOverview3 + '/updateMatterInfo',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}


// 保存培训型号

export function insert2 (parameter) {
  return axios({
    url: api.trainOverview2 + '/insert',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}


// export function insert (parameter) {
//   return axios({
//     url: api.trainOverview2 + '/insert',
//     method: 'post',
//     data: parameter,
//     headers: {
//       'Content-Type': 'application/json;charset=UTF-8'
//     }
//   })
// }


// 删除禁用和启用
export function statusInfo (parameter) {
  return axios({
    url: api.trainOverview3 + '/status',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function modelListUpdate (parameter) {
  return axios({
    url: 'exam/model/update',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

// 删除培训详情
export function deleteInfo (parameter) {
  return axios({
    url: api.trainOverview3 + `/delete/${parameter}`,
    method: 'get'
  })
}

// 查看
export function getInfo (parameter) {
  return axios({
    url: api.trainOverview3 + `/get/${parameter}`,
    method: 'get'
  })
}

// 踩 数量
export function selectInfo (parameter) {
  return axios({
    url: api.trainOverview2+'/selectInfo',
    method: 'get',
    params: parameter
  })
}


export function selectSelectionModel (parameter) {
  return axios({
    url: `exam/model/selectSelectionModel`,
    method: 'get'
  })
}

export function selectModelList (parameter) {
  return axios({
    url: `exam/model/selectModelList`,
    method: 'get',
    params: parameter
  })
}

// 踩 数量
export function selectStepLowerNum (parameter) {
  return axios({
    url: api.trainOverview4 + '/selectStepLowerNum',
    method: 'get',
    params: parameter
  })
}

// 踩列表
export function selectStepLowerList (parameter) {
  return axios({
    url: api.trainOverview4 + '/selectStepLowerList',
    method: 'get',
    params: parameter
  })
}

// 收藏数量
export function selectCollectionNum (parameter) {
  return axios({
    url: api.trainOverview4 + `/selectCollectionNum/${parameter}`,
    method: 'get'
  })
}

// 收藏列表
export function selectCollectionList (parameter) {
  return axios({
    url: api.trainOverview4 + `/selectCollectionList/${parameter}`,
    method: 'get'
  })
}

// 评论数量
export function selectCommentNum (parameter) {
  return axios({
    url: api.trainOverview4 + `/selectCommentNum/${parameter}`,
    method: 'get',
  })
}

// 评论列表
export function selectCommentList (parameter) {
  return axios({
    url: api.trainOverview4 + '/selectCommentList',
    method: 'get',
    params: parameter
  })
}

// 点赞数量
export function selectThumbsUpNum (parameter) {
  return axios({
    url: api.trainOverview4 + `/selectThumbsUpNum/${parameter}`,
    method: 'get',
  })
}

// 点赞列表
export function selectThumbsUpList (parameter) {
  return axios({
    url: api.trainOverview4 + '/selectThumbsUpList',
    method: 'get',
    params: parameter
  })
}

// 培训详情标题
// export function getTitle (parameter) {
//   return axios({
//     url: api.trainOverview3 + `/getTitle/${parameter}`,
//     method: 'get',
//   })
// }
export function getTitle (parameter) {
  return axios({
    url: api.trainOverview3 + '/trainInfoList',
    method: 'get',
    params: parameter,
  })
}

// 注意事项
export function insertInfo (parameter) {
  return axios({
    url: api.trainOverview3 + '/insertInfo',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

// 配置
export function list2 (parameter) {
  return axios({
    url: api.trainOverview2 + '/list',
    method: 'get',
    params: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

// 列表
export function list (parameter) {
  return axios({
    url: api.trainOverview + '/list',
    method: 'get',
    params: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export const accessoryExport = api.accessory + '/export'
